module.exports = __webpack_public_path__ + "img/custom.eabbb046.svg";